import { DataService } from './../../../../../services/data.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../../../../services/common-authentication.service';
import { NotificationService } from './../../../../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';



@Component({
  selector: 'app-student-music-panel',
  templateUrl: './student-music-panel.component.html',
  styleUrls: ['./student-music-panel.component.scss']
})
export class StudentMusicPanelComponent implements OnChanges, OnDestroy {
  @Input() profileData: any;

  musicListJson = [];
  selectedMusicList = [];
  musicTextFlag = true;
  musicText;
  musicFormsTouched = false;
  musicJson = {
    musicClassIds: '',
    otherMusic: ''
  };
  studentUserId: any;
  partnerId: any;

  private destroyed$ = new Subject();

  constructor(
    private notificationService: NotificationService,
    private _commonAuthServices: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private dataService: DataService
  ) {
    this.musicListJson = this.dataService.getEntity('Music').item || [];

    const localStorageData = this._commonAuthServices.getLoginData();
    this.studentUserId = localStorageData.userId;
    this.partnerId = localStorageData.partnerId;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.musicFormsTouched = false;
    this.musicListJson = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileData'] !== undefined && changes['profileData'].currentValue !== undefined) {
      this.setMusicData(changes['profileData'].currentValue || {});
    }
  }

  getMusicData(object: any) {
    this.selectedMusicList = [];

    if (object && object.text === 'Other' && object.checked) {
      this.musicTextFlag = false;
    } else if (object && object.text === 'Other' && !object.checked) {
      this.musicTextFlag = true;
    }

    for (let i = 0; i < this.musicListJson.length; i++) {
      if (this.musicListJson[i].checked) {
        this.selectedMusicList.push(this.musicListJson[i].id)
      }
    }
    const obj = {selectedList: this.selectedMusicList};

    this.commonDataSharedService.studentQuestionaryThreeMusicData.next(obj);
  }

  musicData(item: any) {
    const obj = {musicText: item};
    this.commonDataSharedService.studentQuestionaryThreeMusicTextData.next(obj);

  }

  setMusicData(detailData) {
    if (detailData) {
      this.musicJson = detailData;
      this.musicText = this.musicJson.otherMusic;
      this.musicData(this.musicText);
      if (this.musicJson) {
        if (this.musicListJson) {
          for (let i = 0; i < this.musicListJson.length; i++) {
            if (this.musicJson && this.musicJson.musicClassIds && this.musicJson.musicClassIds.length > 0) {
              for (let j = 0; j < this.musicJson.musicClassIds.length; j++) {
                if (this.musicListJson[i].id === parseInt(this.musicJson.musicClassIds[j], 10)) {
                  this.musicListJson[i].checked = true;
                  this.selectedMusicList.push(this.musicListJson[i].id.toString());
                  this.getMusicData(this.musicListJson[i]);
                }
              }
            }
          }
          const musicObject = {selectedList: this.selectedMusicList};
          this.commonDataSharedService.studentQuestionaryThreeMusicData.next(musicObject);
        }
      }
    }
  }
  changeValue() {
    this.musicFormsTouched = true;
  }
}
